import styled from 'styled-components/macro';
import { Button } from 'ui-component-library';
import { FlexJustifyCenter } from '../../../../shared-styles/flex';
import { InfoSectionHeaderButton, InfoSectionHeaderButtonContainer } from '../../../../shared-styles/info-section-header-button';

export const HeaderButtonsGroup = styled.div`
  ${InfoSectionHeaderButtonContainer}
`;

export const HeaderButton = styled(Button)`
  ${InfoSectionHeaderButton};
  max-height: 24px;
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter}
  width: 540px;
`;
